var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtractIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_106229_subtract_icon",
    "data-name": "106229_subtract_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.191,
    height: 23.191,
    viewBox: "0 0 23.191 23.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54630",
    "data-name": "Group 54630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109049",
    "data-name": "Path 109049",
    d: "M11.6,0a11.6,11.6,0,1,0,11.6,11.6A11.6,11.6,0,0,0,11.6,0Zm0,20.292a8.7,8.7,0,1,1,8.7-8.7A8.7,8.7,0,0,1,11.6,20.292ZM5.8,13.045h11.6v-2.9H5.8Z",
    fill: "#b54747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractIcon);
export default __webpack_public_path__ + "static/media/subtractIcon.622f6aa6d95af877202beee9847a9665.svg";
export { ForwardRef as ReactComponent };